import type { ThreadConversationInterface } from "types/thread";

export const countUnreadConversations = (threads: ThreadConversationInterface[] | undefined): number => {
    if (!threads?.length) {
        return 0;
    }

    return threads.reduce((count, thread) => count + (thread.unread_count > 0 ? 1 : 0), 0);
};
